module.exports = __webpack_public_path__ + "static/media/brain.bdedc1fb.svg";